import { render, staticRenderFns } from "./FeatureBullet.vue?vue&type=template&id=b0fb2b1a&scoped=true&"
import script from "./FeatureBullet.vue?vue&type=script&lang=js&"
export * from "./FeatureBullet.vue?vue&type=script&lang=js&"
import style0 from "./FeatureBullet.vue?vue&type=style&index=0&id=b0fb2b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fb2b1a",
  null
  
)

export default component.exports